import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./ErrorMessage.module.css";

const ErrorMessage = (props) => {
  const { className, message } = props;
  return (
    <p className={classNames(classes["error-message"], className)}>{message}</p>
  );
};

export default ErrorMessage;

ErrorMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
};
